import { useSelector } from 'react-redux';
import Global from '../../../../../../store/global-selectors';

export const useNonLocalDeliveryServicesAvailableForSeller = () => {
  const allServices = useSelector(Global.selectSellerServices);
  return allServices.filter((service) => !service.features?.supportsSameDayService);
};
